export enum moduleWidgetPlacements {
  DEFAULT = 'Default',
  LEFT_MENU = 'LeftMenu',
  RIGHT_OF_OVERVIEW = 'RightOfOverview',
  RIGHT_OF_CALENDAR = 'RightOfCalendar',
  BELOW_OF_CALENDAR = 'BelowCalendar',
  OWN_PAGE = 'OwnPage',
}
